import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { subscriptionActions } from '../../../redux/slices/subscriptionSlice';
import { SubscriptionEntitlements } from '../../../redux/slices/subscriptionSlice';
import { useAppDisPatch, useAppSelector } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetEntitlements = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const { authData } = useAppSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  const getEntitlements = useCallback(async (): Promise<SubscriptionEntitlements | null> => {
    let result: SubscriptionEntitlements | null = null;
    const url: HttpConfig = {
      url: 'auth-service/subscriptions/me/entitlements',
      method: 'get',
      timeout: 15000,
    };
    await request(url, (response: unknown) => {
      const data = (response as SuccessHttpResponse<SubscriptionEntitlements>).data;
      result = data;
      dispatch(subscriptionActions.setEntitlements(data));
    }, setLoading, (err: AxiosError<ErrorHttpResponse>) => {
      console.error('Error fetching entitlements:', err?.message);
      dispatch(subscriptionActions.setEntitlements(null));
      dispatch(subscriptionActions.setEntitlementsError('Unable to verify plan access. Please try again.'));
    });
    return result;
  }, [dispatch, request]);

  useEffect(() => {
    if (authData) {
      getEntitlements();
    }
  }, [authData, getEntitlements]);

  return { getEntitlements, loading };
};

export default useGetEntitlements;
